import SelectOption from '@/view/pages/posm/models/SelectOption';

export default function createFirstSelectionOption(entityName) {
  return new SelectOption(`Chọn ${entityName}`, null);
}
